// extracted by mini-css-extract-plugin
export default {"wrapper":"ZteHP","title":"odfZd"};